import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataDocumentNoteCategory } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_DOCUMENT_NOTE_CATEGORY =
  defineMasterdataEntity<MasterdataDocumentNoteCategory>({
    name: 'document-note-category',
    responseKey: 'documentNoteCategories',
    displayWith: (c) => keyName(c.key, c.name),
    secondaryWith: (c) => c.description,
    icon: 'fa-regular fa-note-sticky',
    title: 'Belegtextartsuche',
    label: 'Belegtextart',
    placeholder: 'Belegtextart suchen...',
    columns: [
      {
        label: 'Belegtextart',
        type: 'entity',
        icon: 'fa-regular fa-note-sticky',
        value: (e) => keyName(e.key, e.name),
        secondary: (e) => e.description,
      },
      { label: 'Schlüssel', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
      { label: 'Beschreibung', type: 'text', value: (e) => e.description },
      { label: 'Kopieren', type: 'text', value: (e) => (e.copy ? 'Ja' : 'Nein') },
      { label: 'Art', type: 'text', value: (e) => e.type?.name ?? null },
    ],
  });
